import config from './config';

const featureFlagging = config({
  /** Defaults for all sites and locales. */
  default: {
    /** Default settings for all languages. */
    default: {
      featureFlagDefaults: {
        /** A feature flag for use in tests. */
        __reservedForTesting: { enabled: true }
      },
      /**
       * The fallback feature present on {@link GTMService} that checks if the dataLayer
       * is present and creating an empty one if not.
       *
       * That exists to workaround an error where the data layer on window gets deleted,
       * and we are featuring flagging it to test a possible fix.
       */
      dataLayerFallback: { prod: true, default: false }
    }
  }
});

export default featureFlagging;
